<template>
  <div>
    <el-row class="dataCards" :gutter="10" type="flex">
      <el-col :md="12" :lg="6" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background:  rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[0].title : '' }}</span>
              <span class="dataText">{{ topCardSmallStats.length ? topCardSmallStats[0].data : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[0].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="6" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[1].title : '' }}</span>
              <span class="dataText"
                >{{ topCardSmallStats.length ? `${topCardSmallStats[1].data}` : '' }}
                <span style="font-weight: 100;">{{ topCardSmallStats.length ? '|' : '' }} </span>
                {{ topCardSmallStats.length ? ` ${((topCardSmallStats[1].data / topCardSmallStats[0].data) * 100).toFixed(0)} %` : '' }}</span
              >
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[1].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="6" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[3].title : '' }}</span>
              <span :class="negativeClass(3)">{{ topCardSmallStats.length ? moneyFormatter(topCardSmallStats[3].data) : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[3].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="6" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[2].title : '' }}</span>
              <span :class="negativeClass(2)">{{ topCardSmallStats.length ? moneyFormatter(topCardSmallStats[2].data) : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[2].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex">
      <el-col :span="24" style="margin: 10px 0px 0px 0px; text-align:left;">
        <el-card class=" reviewCard" shadow="hover">
          <div slot="header">
            <span>Project Data</span>
            <!-- <el-button :title="` ${isClosed ? 'collapse': 'expand'} section`"
              style="float: right; color: #ffffff; font-size: 18px; margin: -6px 0px 0px 0px" type="warning" circle
              @click="expandCollapse"><i
                :class="`mdi ${isClosed ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'}`"></i>
            </el-button> -->
            <span class="expandCollapseButton" :title="` ${isClosed ? 'collapse' : 'expand'} section`" @click="expandCollapse"><i :class="`mdi ${isClosed ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'}`"></i></span>
          </div>
          <div class="reviewTableData" v-loading="loading" element-loading-spinner="nucleus-loader">
            <el-row class="dashboardControlsRow">
              <div class="groupingFilterControls">
                <div class="groupingControl">
                  <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Group Data By:</label>
                  <el-select :disabled="reviewDashboardData.length === 0" :default-first-option="true" :value="ambulatoryGrouping" placeholder="Group Data by" filterable @change="handleGroupDataSelectChange">
                    <el-option v-for="item in dropdown" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
                </div>
                <div class="codeTypeControl">
                  <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Code Type:</label>
                  <el-select :disabled="!codeTypeDropdown.length" style="width: 250px;" :default-first-option="true" v-model="codeTypeGrouping" placeholder="Code Type" multiple filterable clearable collapse-tags @change="handleCodeTypeGrouping" @clear="handleCodeTypeGroupingClear">
                    <el-option v-for="item in codeTypeDropdown" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
                </div>
                <div class="filterEditorContainer">
                  <el-popover :value="isFilterEditorVisibleForGrouping(currentGroupingValue)" placement="bottom-start" width="320" trigger="click" @input="handleFilterEditorVisibilityChange(currentGroupingValue, $event)">
                    <div class="filterEditorPopover" v-loading="filterEditorLoading" element-loading-spinner="nucleus-loader">
                      <div class="filterEditorTitle">{{ editingGroupingConfig ? `${editingGroupingConfig.label} Filters` : 'Filter Group' }}</div>
                      <el-select :ref="getFilterGroupRefName(currentGroupingValue)" :key="getFilterGroupRefName(currentGroupingValue)" :disabled="!filterEditorDropDownGroups.length" style="width: 100%;" :default-first-option="true" v-model="pendingSelectedGrouping" placeholder="Filter Group" multiple filterable clearable collapse-tags>
                        <el-option v-for="item in filterEditorDropDownGroups" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                      </el-select>
                      <div v-if="editingGroupingStickyFilter" class="filterEditorActions">
                        <el-button type="text" @click="clearCurrentGroupingFilterFromPopover">Clear {{ editingGroupingConfig ? editingGroupingConfig.label : 'Filter' }}</el-button>
                      </div>
                    </div>
                    <span slot="reference" class="filterEditorTrigger">
                      <div v-if="currentGroupingStickyFilter" class="filterChip clickableFilterChip activeFilterChip" :title="formatStickyGroupingFilter(currentGroupingStickyFilter)">
                        <span class="truncatedFilterChipLabel">{{ formatStickyGroupingFilter(currentGroupingStickyFilter) }}</span>
                        <span class="currentFilterChipClose" title="Clear filter" @click.stop.prevent="clearCurrentGroupingFilterQuick">
                          <i class="mdi mdi-close"></i>
                        </span>
                      </div>
                      <div v-else class="filterChip clickableFilterChip placeholderFilterChip">
                        +
                        <i class="mdi mdi-filter-outline"></i>
                      </div>
                    </span>
                  </el-popover>
                </div>
                <div v-if="otherStickyGroupingFilters.length" class="inlineStickyFilters">
                  <el-popover v-for="filter in otherStickyGroupingFilters" :key="filter.grouping" :value="isFilterEditorVisibleForGrouping(filter.grouping)" placement="bottom-start" width="320" trigger="click" @input="handleFilterEditorVisibilityChange(filter.grouping, $event)">
                    <div class="filterEditorPopover" v-loading="filterEditorLoading" element-loading-spinner="nucleus-loader">
                      <div class="filterEditorTitle">{{ editingGroupingConfig ? `${editingGroupingConfig.label} Filters` : 'Filter Group' }}</div>
                      <el-select :ref="getFilterGroupRefName(filter.grouping)" :key="getFilterGroupRefName(filter.grouping)" :disabled="!filterEditorDropDownGroups.length" style="width: 100%;" :default-first-option="true" v-model="pendingSelectedGrouping" placeholder="Filter Group" multiple filterable clearable collapse-tags>
                        <el-option v-for="item in filterEditorDropDownGroups" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                      </el-select>
                      <div v-if="editingGroupingStickyFilter" class="filterEditorActions">
                        <el-button type="text" @click="clearCurrentGroupingFilterFromPopover">Clear {{ editingGroupingConfig ? editingGroupingConfig.label : 'Filter' }}</el-button>
                      </div>
                    </div>
                    <span slot="reference" class="filterEditorTrigger">
                      <div class="filterChip inlineStickyFilterChip clickableFilterChip passiveFilterChip" :title="formatStickyGroupingFilter(filter)">
                        <span class="truncatedFilterChipLabel">{{ formatStickyGroupingFilter(filter) }}</span>
                        <button type="button" class="stickyFilterChipClose" title="Clear filter" @click.stop.prevent="clearStickyGroupingFilter(filter.grouping)">
                          <i class="mdi mdi-close"></i>
                        </button>
                      </div>
                    </span>
                  </el-popover>
                </div>
              </div>
              <div class="rightControlActions">
                <div class="searchControl">
                  <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria" @keyup.native="filterGroupUpdate"></el-input>
                </div>
                <div class="menuControl">
                  <el-dropdown class="tableOptions" title="Table Options" trigger="click" @command="actionMenuCommands" size="medium">
                    <span class="el-dropdown-link">
                      <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="width: 190px;" class="documentActionMenu">
                      <el-dropdown-item :command="{ action: 'toggleChartData' }"><i style="margin-right: 6px;" :class="toggleChartData ? 'mdi mdi-chart-bar-stacked' : 'mdi mdi-table-large'"></i>{{ toggleChartData ? 'Toggle Chart' : 'Toggle Data' }} </el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'downloadCSV' }"><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'comparisonAccounts' }">
                        <el-checkbox class="bedSizeCompare" :disabled="!reviewDashboardData.length > 0" v-model="activateComparison" @input="handleActivateComparison">Ambulatory Compare</el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-row>
            <el-row v-if="activateComparison">
              <div style="float: left; margin: 0px 0px 10px 0px; width: 250px;">
                <div style="float: left; width: 30%; text-align: center;">
                  <i :title="`${currentClient} data`" style="font-size: 23px; margin: 0px 0px 0px 0px; color: rgba(19, 86, 149, .8);" class="mdi mdi-set-center"></i>
                  <span style="display: block; font-size: 12px; color: #303133;">{{ `${currentClient}` }}<br />reviews</span>
                </div>
                <div style="float: left; width: 30%; text-align: center;">
                  <i title="All HIA bed size data" style="font-size: 23px; margin: 0px 0px 0px 0px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
                  <span style="display: block; font-size: 12px; color: #303133;">All bed size reviews</span>
                </div>
              </div>
            </el-row>
            <el-row>
              <AmbulatoryTables :class="toggleChartData ? 'vshow' : 'vhide'" ref="opTables" :grouping="ambulatoryGrouping" :codeTypeGrouping="codeTypeGrouping" :dropdown="dropdown" :filterCriteria="filterCriteria" :selectedGrouping="selectedGrouping" :activateComparison="activateComparison" :bedSize="bedSize"> </AmbulatoryTables>
              <AmbulatoryCharts :class="!toggleChartData ? 'vshow' : 'vhide'" :grouping="ambulatoryGrouping" :codeTypeGrouping="codeTypeGrouping" :filterCriteria="filterCriteria" :isClosed="isClosed" :selectedGrouping="selectedGrouping"> </AmbulatoryCharts>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions, mapMutations } from 'vuex'
import AmbulatoryTables from '@/views/Dashboards/AmbulatoryTables'
import AmbulatoryCharts from '@/views/Dashboards/AmbulatoryCharts'
import hiaFilters from '@/mixins/hiaFilters'
import csvGenerator from '@/mixins/csvGenerator'
import createStickyGroupingMixin from '@/mixins/reviewDashboardStickyGrouping'
import { format } from 'date-fns'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'dashboard/getField',
  mutationType: 'dashboard/updateField'
})

const AMBULATORY_GROUPING_CONFIG = {
  '1': { title: 'By Coder', key: 'coder', label: 'Coder' },
  '16': { title: 'By Coder Trending', key: 'coder', label: 'Coder Trending' },
  '3': { title: 'By Patient Type', key: 'patTypeDesc', label: 'Patient Type' },
  '5': { title: 'By Facility', key: 'cliName', label: 'Facility' },
  '6': { title: 'By Reason', key: 'description', label: 'ASC Reason' },
  '7': { title: 'By Header Reason', key: 'changeDesc', label: 'Record Reason' },
  '17': { title: 'By Service Line', key: 'clientServiceLineName', label: 'Service Line' },
  '8': { title: 'By Dx', key: 'code', label: 'Dx' },
  '15': { title: 'By SDOH Dx', key: 'code', label: 'SDOH' },
  '12': { title: 'By HCC', key: 'code', label: 'HCC V24' },
  '14': { title: 'By HCC V28', key: 'code', label: 'HCC V28' },
  '9': { title: 'By CPT', key: 'code', label: 'CPTs with Reimb.' },
  '13': { title: 'By CPT No Reimb', key: 'code', label: 'CPTs without Reimb.' },
  '10': { title: 'By MOD', key: 'code', label: 'MOD' }
}

const stickyGroupingMixin = createStickyGroupingMixin({
  groupingField: 'ambulatoryGrouping',
  stickyFiltersField: 'ambulatoryStickyGroupingFilters',
  dashboardDataField: 'ambData',
  groupingConfigMap: AMBULATORY_GROUPING_CONFIG,
  fetchDashboardMethod: 'fetchAmbulatoryGroupingDashboard',
  loadGroupingMethod: 'loadAmbulatoryGrouping',
  filterRowsMethod: 'filterStickyScopeRows'
})

export default {
  data: function() {
    return {
      filterCriteria: '',
      toggleChartData: true,
      grouping: '5',
      loading: false,
      codeTypeGrouping: [],
      dropdown: [{ key: '1', value: 'Coder', dbValue: 'coder' }, { key: '16', value: 'Coder Trending' }, { key: '3', value: 'Patient Type', dbValue: 'patTypeDesc' }, { key: '5', value: 'Facility', dbValue: 'cliName' }, { key: '6', value: 'ASC Reason', dbValue: 'description' }, { key: '7', value: 'Record Reason', dbValue: 'changeDesc' }, { key: '17', value: 'Service Line', dbValue: 'clientServiceLineName' }, { key: '8', value: 'Dx', dbValue: 'code' }, { key: '15', value: 'SDOH', dbValue: 'code' }, { key: '12', value: 'HCC V24', dbValue: 'code' }, { key: '14', value: 'HCC V28', dbValue: 'code' }, { key: '9', value: 'CPTs with Reimb.', dbValue: 'code' }, { key: '13', value: 'CPTs without Reimb.', dbValue: 'code' }, { key: '10', value: 'MOD', dbValue: 'code' }],
      selectedRows: [],
      groupKey: '',
      selectedGrouping: [],
      previousCodeTypeGrouping: [],
      activateComparison: false,
      bedSize: '0 - 99'
    }
  },
  name: 'ReviewDashboard',
  mixins: [HiaAuthorization, money, hiaFilters, csvGenerator, stickyGroupingMixin],
  props: {
    dateRange: { type: Array },
    isClosed: { type: Boolean },
    bedSizeDropdown: { type: Array }
  },
  components: {
    AmbulatoryTables,
    AmbulatoryCharts
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS', 'GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_ALL', 'GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE', 'POST_REVIEW_DASHBOARD_AMB']),
    ...mapMutations('dashboard/', ['SET_AMB_REVIEW_DASHBOARD', 'SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE', 'SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB']),
    getDefaultCodeTypeGrouping() {
      const codeTypes = this.ambData && this.ambData.length ? this.ambData[0].codeTypes : null
      if (!Array.isArray(codeTypes) || !codeTypes.length) {
        return []
      }
      return codeTypes.some(x => x && x.key === 'Coder Assigned') ? ['Coder Assigned'] : []
    },
    syncCodeTypeGrouping(grouping = this.ambulatoryGrouping) {
      if (grouping === '7') {
        this.codeTypeGrouping = []
        return
      }

      if (this.codeTypeGrouping && this.codeTypeGrouping.length) {
        this.previousCodeTypeGrouping = this.codeTypeGrouping
        return
      }

      if (this.previousCodeTypeGrouping && this.previousCodeTypeGrouping.length) {
        this.codeTypeGrouping = this.previousCodeTypeGrouping
        return
      }

      this.codeTypeGrouping = this.getDefaultCodeTypeGrouping()
    },
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    negativeClass(i) {
      if (this.topCardSmallStats.length) {
        return this.topCardSmallStats[i].data < 0 ? 'dataText negative' : 'dataText'
      }
      return 'dataText'
    },
    buildAmbulatoryRequestPayload(grouping, selectedAccountNumbers = this.getCombinedStickyAccountNumbers()) {
      return {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        projects: this.selectedProjects,
        ambulatoryGrouping: grouping,
        selectedAccountNumbers
      }
    },
    fetchAmbulatoryGroupingDashboard(grouping, selectedAccountNumbers = null) {
      if (this.selectedProjects.length <= 0) {
        return Promise.resolve(null)
      }

      return this.POST_REVIEW_DASHBOARD_AMB(this.buildAmbulatoryRequestPayload(grouping, selectedAccountNumbers)).then(response => response.data[0] || null)
    },
    applyAmbulatoryGroupingResponse(newValue, mainClientResponse) {
      let tasks = []

      if (this.activateComparison) {
        let minDate = format(new Date(Math.min.apply(null, this.selectedProjects.map(x => new Date(x.startDate)))), 'MM-dd-yyyy')
        let maxDate = format(new Date(Math.max.apply(null, this.selectedProjects.map(x => new Date(x.endDate)))), 'MM-dd-yyyy')

        let payload = {
          grouping: newValue,
          startDate: minDate,
          endDate: maxDate,
          bedSize: this.bedSize,
          allData: false,
          reviewType: 'amb',
          groupList: this.getGroupDropDown(newValue),
          codeTypes: [],
          noMutation: true
        }

        let payloadCopy = JSON.parse(JSON.stringify(payload))
        payloadCopy.bedSize = 'all'
        payloadCopy.allData = true
        tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_ALL(payloadCopy))
      }

      if (tasks.length > 0) {
        return Promise.all(tasks).then(
          response => {
            this.loading = false
            this.ambulatoryGrouping = newValue
            this.$nextTick(() => {
              this.SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB(response[0].data)
              this.SET_AMB_REVIEW_DASHBOARD(mainClientResponse)
            })
          },
          e => {
            if (e.response && e.response.data) {
              if (e.response.data.status === 502) {
                this.$message({
                  type: 'error',
                  message: 'Request included a large data set and timed out, please try again',
                  duration: 10000
                })
              }
              this.ambulatoryGrouping = newValue
              this.loading = false
            }
          }
        )
      }

      this.loading = false
      this.ambulatoryGrouping = newValue
      this.$nextTick(() => {
        this.SET_AMB_REVIEW_DASHBOARD(mainClientResponse)
      })

      return Promise.resolve()
    },
    loadAmbulatoryGrouping(newValue, mainClientResponseOverride) {
      if (this.selectedProjects.length <= 0) {
        this.ambulatoryGrouping = newValue
        return Promise.resolve()
      }

      this.loading = true
      if (mainClientResponseOverride !== undefined) {
        return this.applyAmbulatoryGroupingResponse(newValue, mainClientResponseOverride)
      }

      return this.POST_REVIEW_DASHBOARD_AMB(this.buildAmbulatoryRequestPayload(newValue)).then(response => this.applyAmbulatoryGroupingResponse(newValue, response.data[0]))
    },
    filterStickyScopeRows(rows) {
      if (!this.codeTypeGrouping.length) {
        return rows
      }

      return rows.filter(row => {
        let match = false
        this.codeTypeGrouping.forEach(codeType => {
          if (row.codeDesc === codeType) {
            match = true
          }
        })
        return match
      })
    },
    handleGroupDataSelectChange(newValue) {
      this.filterCriteria = ''
      this.loadAmbulatoryGrouping(newValue)
    },
    handleCodeTypeGrouping(val) {
      if (val.toString().includes('selectAll')) {
        // this.codeTypeGrouping = this.codeTypeDropdown.map(x => x.key)
      }
    },
    handleCodeTypeGroupingClear() {
      this.previousCodeTypeGrouping = []
    },
    handleToggleChartData() {
      this.toggleChartData = !this.toggleChartData
    },
    expandCollapse() {
      this.$emit('expandCollapse', null)
    },
    handleArrayToCsv() {
      // let headers = []
      switch (this.ambulatoryGrouping) {
        case '1':
          this.tableToCsv(this.$refs.opTables.$refs.opCoderTable.$el, 'coder_table.csv', [])
          break
        case '16':
          this.tableToCsv(this.$refs.opTables.$refs.opCoderTrendingTable.$el, 'coderTrending_table.csv', [])
          break
        case '2':
          this.tableToCsv(this.$refs.opTables.$refs.opApcTable.$el, 'apc_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '3':
          this.tableToCsv(this.$refs.opTables.$refs.opPatientTypeTable.$el, 'patienttype_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '5':
          this.tableToCsv(this.$refs.opTables.$refs.opFacilityTable.$el, 'facility_table.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '6':
          this.tableToCsv(this.$refs.opTables.$refs.opReasonTable.$el, 'reason_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '7':
          this.tableToCsv(this.$refs.opTables.$refs.opHeaderReasonTable.$el, 'record_reason_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '8':
          this.paginationArrayToCsv('dx')
          break
        case '15':
          this.paginationArrayToCsv('sdoh')
          break
        case '12':
          this.tableToCsv(this.$refs.opTables.$refs.opHccTable.$el, 'hccv24_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '14':
          this.tableToCsv(this.$refs.opTables.$refs.opHccV28Table.$el, 'hccv28_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '9':
          this.paginationArrayToCsv('cpt')
          break
        case '13':
          this.paginationArrayToCsv('cpt')
          break
        case '10':
          this.tableToCsv(this.$refs.opTables.$refs.opModTable.$el, 'mod_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '11':
          this.paginationArrayToCsv('px')
          break
        case '17':
          this.tableToCsv(this.$refs.opTables.$refs.opServiceLineTable.$el, 'serviceLine_table.csv', [])
          break
      }
    },
    actionMenuCommands(object) {
      if (object.action === 'toggleChartData') {
        this.handleToggleChartData()
      }
      if (object.action === 'downloadCSV') {
        this.handleArrayToCsv()
      }
    },
    groupDropDownFilter(data, currentTable, key) {
      return data.filter(x => {
        if (currentTable.some(y => y[key].toString() === x.key.toString())) {
          return x
        }
      })
    },
    handleActivateComparison() {
      if (this.activateComparison && !this.comparisonAccountsOP.length) {
        this.handleGetDashboardComparisonAccounts(true)
      }
    },
    handleBedSizeChange() {
      this.handleGetDashboardComparisonAccounts(false)
    },
    handleGetDashboardComparisonAccounts(allData) {
      let minDate = format(new Date(Math.min.apply(null, this.selectedProjects.map(x => new Date(x.startDate)))), 'MM-dd-yyyy')
      let maxDate = format(new Date(Math.max.apply(null, this.selectedProjects.map(x => new Date(x.endDate)))), 'MM-dd-yyyy')
      let payload = {
        grouping: this.ambulatoryGrouping,
        startDate: minDate,
        endDate: maxDate,
        bedSize: this.bedSize,
        allData: allData,
        reviewType: 'amb',
        groupList: [],
        codeTypes: this.getCodeTypeDropdown()
      }

      let tasks = []

      this.$emit('comparisonLoading', true)

      // tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE(payload))
      if (allData) {
        // only sometimes get All
        let payloadCopy = JSON.parse(JSON.stringify(payload))
        payloadCopy.bedSize = 'all'
        tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_ALL(payloadCopy))
      }

      Promise.all(tasks).then(
        response => {
          this.$emit('comparisonLoading', false)
        },
        e => {
          if (e.response && e.response.data) {
            if (e.response.data.status === 502) {
              this.$message({
                type: 'error',
                message: 'Request included a large data set and timed out, please try again',
                duration: 10000
              })
            }
            this.$emit('comparisonLoading', false)
          }
        }
      )
    },

    getTableData(grouping) {
      if (!this.reviewDashboardData) {
        return []
      }

      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null && this.reviewDashboardData[opIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[opIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.codeTypeGrouping.length) {
          data = data.filter(x => {
            let val
            this.codeTypeGrouping.forEach(y => {
              if (x.codeDesc === y) {
                val = x
              }
            })
            return val
          })
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    filterGroupUpdate() {
      this.$nextTick(() => {
        this.dropDownGroups = this.filterEditorDropDownGroups
      })
    },
    groupDropDown(grouping = this.ambulatoryGrouping) {
      return this.getFilterGroupOptions(grouping)
    },
    getGroupDropDown(grouping) {
      return this.getFilterGroupOptions(grouping)
    },
    getCodeTypeDropdown() {
      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null) {
        return this.reviewDashboardData[opIndex].codeTypes !== null ? this.reviewDashboardData[opIndex].codeTypes : []
      }
      return []
    },
    paginationArrayToCsv(table) {
      let data = []
      let comparsionData = []
      let headers = []
      let keys = []
      let summaryRow = {}

      switch (table) {
        case 'dx':
          data = Object.assign([], this.$refs.opTables.dxTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })
            // update specifics
            item.cmCodes = this.$refs.opTables.totalPercentSummaries('cmCodes', [x], 0, { label: 'Accuracy Rate' })

            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, false, null, 'dx')
              child2.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, false, null, 'dx')
              child2.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, false, null, 'dx')
              child2.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, false, null, 'dx')
              child2.cmCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cmCodes', child1.codeDesc, false, null, 'dx')

              child3.compare = 'All HIA bed size data'
              child3.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, true, null, 'dx')
              child3.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, true, null, 'dx')
              child3.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, true, null, 'dx')
              child3.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, true, null, 'dx')
              child3.cmCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cmCodes', child1.codeDesc, true, null, 'dx')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.cmCodes = this.$refs.opTables.totalPercentSummaries('cmCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.opTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'codeDesc', value: 'Code Type' }, { key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'cmCodes', value: 'Accuracy Rate' }]

          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'dx_table.csv', headers)
          break
        case 'sdoh':
          data = Object.assign([], this.$refs.opTables.sdohTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })
            // update specifics
            item.cmCodes = this.$refs.opTables.totalPercentSummaries('cmCodes', [x], 0, { label: 'Accuracy Rate' })

            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, false, null, 'dx')
              child2.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, false, null, 'dx')
              child2.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, false, null, 'dx')
              child2.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, false, null, 'dx')
              child2.cmCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cmCodes', child1.codeDesc, false, null, 'dx')

              child3.compare = 'All HIA bed size data'
              child3.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, true, null, 'dx')
              child3.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, true, null, 'dx')
              child3.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, true, null, 'dx')
              child3.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, true, null, 'dx')
              child3.cmCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cmCodes', child1.codeDesc, true, null, 'dx')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.cmCodes = this.$refs.opTables.totalPercentSummaries('cmCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.opTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'codeDesc', value: 'Code Type' }, { key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'cmCodes', value: 'Accuracy Rate' }]

          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'sdoh_table.csv', headers)
          break
        case 'px':
          data = Object.assign([], this.$refs.opTables.pxTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })

            // update specifics
            item.pcsCodes = this.$refs.opTables.totalPercentSummaries('pcsCodes', [x], 0, { label: 'Accuracy Rate' })

            // add comparison title
            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, false, null, 'px')
              child2.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, false, null, 'px')
              child2.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, false, null, 'px')
              child2.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, false, null, 'px')
              child2.pcsCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'pcsCodes', child1.codeDesc, false, null, 'px')

              child3.compare = 'All HIA bed size data'
              child3.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, true, null, 'px')
              child3.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, true, null, 'px')
              child3.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, true, null, 'px')
              child3.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, true, null, 'px')
              child3.pcsCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'pcsCodes', child1.codeDesc, true, null, 'px')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.pcsCodes = this.$refs.opTables.totalPercentSummaries('pcsCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.opTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'codeDesc', value: 'Code Type' }, { key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'pcsCodes', value: 'Accuracy Rate' }]

          //  add comparison header/summary
          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'px_table.csv', headers)
          break
        case 'cpt':
          data = Object.assign([], this.$refs.opTables.cptTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })

            // update specifics
            item.cptCodes = this.$refs.opTables.totalPercentSummaries('cptCodes', [x], 0, { label: 'Accuracy Rate' })

            // add comparison title
            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, false, null, 'cpt')
              child2.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, false, null, 'cpt')
              child2.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, false, null, 'cpt')
              child2.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, false, null, 'cpt')
              child2.cptCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cptCodes', child1.codeDesc, false, null, 'cpt')

              child3.compare = 'All HIA bed size data'
              child3.codeDesc = this.$refs.opTables.getBedSizeValue('code', child1.code, 'codeDesc', child1.codeDesc, true, null, 'cpt')
              child3.code = this.$refs.opTables.getBedSizeValue('code', child1.code, 'code', child1.codeDesc, true, null, 'cpt')
              child3.description = this.$refs.opTables.getBedSizeValue('code', child1.code, 'description', child1.codeDesc, true, null, 'cpt')
              child3.totalRecords = this.$refs.opTables.getBedSizeValue('code', child1.code, 'totalRecords', child1.codeDesc, true, null, 'cpt')
              child3.cptCodes = this.$refs.opTables.getBedSizeValue('code', child1.code, 'cptCodes', child1.codeDesc, true, null, 'cpt')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.cptCodes = this.$refs.opTables.totalPercentSummaries('cptCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.opTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'codeDesc', value: 'Code Type' }, { key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'cptCodes', value: 'Accuracy Rate' }]

          //  add comparison header/summary
          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'cpt_table.csv', headers)
          break
      }
    }
  },
  created: function() {},
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccounts', 'selectedProjects', 'comparisonAccountsOP', 'ambulatoryGrouping', 'reviewDashboardBaselineSmallStatsAMB']),
    ...mapFields(['ambulatoryGrouping', 'ambulatoryStickyGroupingFilters']),
    topCardSmallStats() {
      return this.reviewDashboardBaselineSmallStatsAMB
    },
    ambData() {
      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null) {
        return [this.reviewDashboardData[opIndex]]
      }
      return []
    },
    codeTypeDropdown() {
      if (this.ambulatoryGrouping === '7') {
        // Header Reason - don't enable
        return []
      }
      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null) {
        return this.reviewDashboardData[opIndex].codeTypes !== null ? this.reviewDashboardData[opIndex].codeTypes : []
      }
      return []
    },
    filterEditorDropDownGroups() {
      const grouping = this.getActiveFilterEditorGrouping()
      const sourceDashboard = this.getFilterGroupSelectionSourceDashboard(grouping)
      const { config, rows } = this.getStickyScopeSourceRows(grouping, sourceDashboard)
      if (!config) {
        return []
      }

      let filteredRows = rows
      if (this.filterCriteria.length) {
        filteredRows = this.filterList(filteredRows, this.filterCriteria)
      }

      return this.groupDropDownFilter(this.getFilterGroupOptions(grouping, sourceDashboard), filteredRows, config.key)
    }
  },
  watch: {
    ambData: {
      handler: function() {
        this.syncCodeTypeGrouping(this.ambulatoryGrouping)
        this.dropDownGroups = this.filterEditorDropDownGroups
      },
      deep: true
    },
    ambulatoryGrouping(newValue, oldValue) {
      this.openFilterEditorGrouping = null
      this.resetFilterGroupSelectionSource()
      this.dropDownGroups = this.filterEditorDropDownGroups
      this.setCurrentGroupingSelections()
      this.setFilterEditorSelections(this.ambulatoryGrouping)
      this.syncCodeTypeGrouping(this.ambulatoryGrouping)
    }
  }
}
</script>

<style scoped>
#reviewTabs {
  margin: 0px 0px 0px 0px;
}

#reviewTabs >>> .el-tabs__nav-wrap::after {
  background-color: transparent;
}

>>> .projectsClosed {
  width: 0%;
  visibility: hidden;
}

>>> .projectsOpen {
  /* visibility: visible;
    width: 20.83333%; */
}

>>> .reviewGridClosed {
  /* width: 100%; */
}

>>> .reviewGridOpen {
  /* width: 77.17%; */
}

>>> .togglePaneClosed {
  /* border-left: 1px solid rgb(235, 238, 245);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; */
}

#reviewLargeStat1 >>> .el-checkbox__inner {
  border-radius: 10px;
}

#projectPane:hover ~ #togglePane > #togglePaneRow {
  /* webkit-box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1); */
}

.reviewTableData >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
  /* background: rgb(238, 238, 238); */
}

.tableIcon {
  font-size: 16px;
  float: left;
  height: 12px;
  margin: -3px 5px 0 0;
}
</style>
